import { pgTable, uuid, foreignKey } from 'drizzle-orm/pg-core';
import { orgTableBase, orgPrimaryKey } from './org-id';
import { AthleteTransferActionEnum, Block, Profile, Team, Track, } from '../schema';
// Holds a reference to a SINGLE-ATHLETE track where the athlete has been
// transferred to a new team
export const AthleteTransferredTrack = pgTable('athlete_transferred_track', {
    ...orgTableBase,
    profileId: uuid('profile_id').notNull(),
    oldTeamId: uuid('old_team_id').notNull(),
    newTeamId: uuid('new_team_id').notNull(),
    trackId: uuid('track_id').notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    oldTeamFk: foreignKey({
        columns: [table.orgId, table.oldTeamId],
        foreignColumns: [Team.orgId, Team.id],
    }),
    newTeamFk: foreignKey({
        columns: [table.orgId, table.newTeamId],
        foreignColumns: [Team.orgId, Team.id],
    }),
    trackFk: foreignKey({
        columns: [table.orgId, table.trackId],
        foreignColumns: [Track.orgId, Track.id],
    }),
    profileFk: foreignKey({
        columns: [table.orgId, table.profileId],
        foreignColumns: [Profile.orgId, Profile.id],
    }),
}));
export const AthleteTransferredBlock = pgTable('athlete_transferred_block', {
    ...orgTableBase,
    profileId: uuid('profile_id').notNull(),
    oldTeamId: uuid('old_team_id').notNull(),
    newTeamId: uuid('new_team_id').notNull(),
    blockId: uuid('block_id').notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    oldTeamFk: foreignKey({
        columns: [table.orgId, table.oldTeamId],
        foreignColumns: [Team.orgId, Team.id],
    }),
    newTeamFk: foreignKey({
        columns: [table.orgId, table.newTeamId],
        foreignColumns: [Team.orgId, Team.id],
    }),
    blockFk: foreignKey({
        columns: [table.orgId, table.blockId],
        foreignColumns: [Block.orgId, Block.id],
    }),
    profileFk: foreignKey({
        columns: [table.orgId, table.profileId],
        foreignColumns: [Profile.orgId, Profile.id],
    }),
}));
export const PotentialAthleteTransfer = pgTable('potential_athlete_transfer', {
    ...orgTableBase,
    profileId: uuid('profile_id').notNull(),
    teamId: uuid('team_id').notNull(),
    action: AthleteTransferActionEnum().notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    teamFk: foreignKey({
        columns: [table.orgId, table.teamId],
        foreignColumns: [Team.orgId, Team.id],
    }),
    profileFk: foreignKey({
        columns: [table.orgId, table.profileId],
        foreignColumns: [Profile.orgId, Profile.id],
    }),
}));
//# sourceMappingURL=transfers.js.map